require('../../modules/es.string.bold');
var entryUnbind = require('../../internals/entry-unbind');

module.exports = entryUnbind('String', 'bold');
